goog.module('yext.developerapps.marketoleadgen.init');
goog.module.declareLegacyNamespace();

const LeadGen = goog.require('yext.developerapps.common.LeadGen');

$(document).ready(function() {
  var initIdentifier = $('.js-marketoleadgen-init').data('jsinit');
  switch (initIdentifier) {
    case 'leadgen':
      var data = $('.js-marketoleadgen-init').data('json');
      new LeadGen(data);
      break;
  }
});

